"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.descAttributes = exports.mediaTrackAttributes = exports.mediaSourceAttributes = exports.videoPosterAttributes = exports.fallbackAttributes = exports.videoAttributes = exports.audioAttributes = exports.imageAttributes = exports.commonAttributes = void 0;
/**
 * Common attributes for all media nodes
 */
exports.commonAttributes = {
    // %localization;
    dir: undefined,
    "xml:lang": undefined,
    translate: undefined,
    // classes
    outputclass: undefined,
    class: undefined,
};
/**
 * Attributes for image nodes
 */
exports.imageAttributes = Object.assign(Object.assign({}, exports.commonAttributes), { height: undefined, width: undefined, keyref: undefined, 
    // %reference-content;
    href: undefined, format: undefined, scope: undefined });
/**
 * Attributes for audio nodes
 */
exports.audioAttributes = Object.assign(Object.assign({}, exports.commonAttributes), { autoplay: undefined, controls: undefined, loop: undefined, muted: undefined, tabindex: undefined, keyref: undefined, 
    // %reference-content;
    href: undefined, format: undefined, scope: undefined, 
    // %filters;
    props: undefined, 
    // %reuse;
    id: undefined, conref: undefined });
/**
 * Attributes for video nodes
 */
exports.videoAttributes = Object.assign(Object.assign({}, exports.commonAttributes), { autoplay: undefined, controls: undefined, loop: undefined, muted: undefined, tabindex: undefined, height: undefined, width: undefined, 
    // %reference-content;
    href: undefined, format: undefined, scope: undefined, 
    // %filters;
    props: undefined, 
    // %reuse;
    id: undefined, conref: undefined });
/**
 * Attributes for fallback nodes
 */
exports.fallbackAttributes = Object.assign(Object.assign({}, exports.commonAttributes), { props: undefined });
/**
 * Attributes for video-poster nodes
 */
const videoPosterAttributes = (attrs) => {
    return {
        dir: attrs === null || attrs === void 0 ? void 0 : attrs.dir,
        "xml:lang": attrs === null || attrs === void 0 ? void 0 : attrs["xml:lang"],
        translate: attrs === null || attrs === void 0 ? void 0 : attrs.translate,
        props: attrs === null || attrs === void 0 ? void 0 : attrs.props,
        href: attrs === null || attrs === void 0 ? void 0 : attrs.href,
        format: attrs === null || attrs === void 0 ? void 0 : attrs.format,
        scope: attrs === null || attrs === void 0 ? void 0 : attrs.scope,
        id: attrs === null || attrs === void 0 ? void 0 : attrs.id,
        conref: attrs === null || attrs === void 0 ? void 0 : attrs.conref,
        keyref: attrs === null || attrs === void 0 ? void 0 : attrs.keyref,
        outputclass: attrs === null || attrs === void 0 ? void 0 : attrs.outputclass,
        class: attrs === null || attrs === void 0 ? void 0 : attrs.class,
    };
};
exports.videoPosterAttributes = videoPosterAttributes;
/**
 * Attributes for media-source nodes
 */
exports.mediaSourceAttributes = Object.assign(Object.assign({}, exports.commonAttributes), { keyref: undefined, 
    // %reference-content;
    href: undefined, format: undefined, scope: undefined });
/**
 * Attributes for media-track nodes
 */
exports.mediaTrackAttributes = Object.assign(Object.assign({}, exports.commonAttributes), { 
    // %reference-content;
    href: undefined, format: undefined, scope: undefined, keyref: undefined, kind: undefined, srclang: undefined });
/**
 * Attributes for desc nodes
 */
exports.descAttributes = Object.assign({ props: undefined }, exports.commonAttributes);
//# sourceMappingURL=attributes.js.map